import {
    DEALERGETTRANSACTIONMASTERLIST_SUCCESS,
    DEALERGETTRANSACTIONMASTERLIST_FAILED,
    RESET_DEALERGETTRANSACTIONMASTERLIST,
    LOADING_DEALERGETTRANSACTIONMASTERLIST,
    NETWORK_ERROR_DEALERGETTRANSACTIONMASTERLIST
} from '../types/index'

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERGETTRANSACTIONMASTERLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERGETTRANSACTIONMASTERLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERGETTRANSACTIONMASTERLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERGETTRANSACTIONMASTERLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERGETTRANSACTIONMASTERLIST:
            return (state = initialState);
        default:
            return state;
    }
};